import type {
    AcceptCommerceShareRequest,
    AcceptCommerceShareResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const acceptCommerceShareOperation = defineCommerceOperation<
    AcceptCommerceShareRequest,
    AcceptCommerceShareResponse
>("commerce.share.accept");
